import { Component, OnInit } from '@angular/core';
import {  FormGroup, FormBuilder, Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import swal from 'sweetalert2';
import { GenericoService } from 'src/app/shared/services/generico.service';
import { UrlConstantes } from 'src/app/utilerias/constantes/urlconstantes';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { firstValueFrom } from 'rxjs';


declare var $: any;

@Component({
    selector: 'app-modalEmail',
    templateUrl: './modalEmail.component.html',
    styleUrls: ['./modalEmail.component.css'],
    imports: [
      FormsModule,
      ReactiveFormsModule,
      CommonModule,
      MatFormFieldModule,
      MatExpansionModule,
      MatIconModule
    ],
})
export class ModalEmailComponent implements OnInit {

    formulario: FormGroup;

    emailFormControl = new FormControl('', [
      Validators.required,
      Validators.email,
    ]);
  
  constructor(private genService: GenericoService, 
    public dialogRef: MatDialogRef<ModalEmailComponent>, 
    private formBuilder: FormBuilder) { }

  ngOnInit() {
      this.formreg();
  }

  formreg() {
    this.formulario = this.formBuilder.group({
      correo: ['', [Validators.required,Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]]
    });
  }
  
  enviarCorreo(){      
    firstValueFrom(
      this.genService.ejecutaServicioSinObtenerElemento(
        UrlConstantes.recuperaPass,
        this.formulario.value.correo
      )
    ).then(response =>{
      this.muestraMensaje(response);
    });
  }

  muestraMensaje(respuesta: any){
    switch(respuesta.pCodRetorno){
      case "00000": /*Exitoso*/
      swal.fire({
        title: "¡Exitoso!",
        text: respuesta.pMensaje,
        timer: 5000,
        showConfirmButton: false,
        icon: "success",
     
    }).then(response =>{
      this.dialogRef.close();
    });

        break;

      case "00001": /*Correo incorrecto*/
      swal.fire({
        title: "¡Error!",
        text: respuesta.pMensaje,
        timer: 5000,
        showConfirmButton: false,
        icon: 'error'
    })
        break;

      case "00002": /*Error de peticion*/
      swal.fire({
        title: "¡Error!",
        text: respuesta.pMensaje,
        timer: 5000,
        showConfirmButton: false,
        icon: 'error',
      
    }).then(response =>{
      this.dialogRef.close();
    });
        break;
    }
    
  }

}
